package com.mgacreative.hotel.feature.channelmanager.di

import com.mgacreative.hotel.feature.channelmanager.data.ChannelManagerRepository
import com.mgacreative.hotel.feature.channelmanager.domain.ChannelManagerService
import com.mgacreative.hotel.feature.channelmanager.ui.ChannelManagerViewModel
import com.mgacreative.hotel.feature.channelmanager.ui.AgencyAllotmentViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getChannelManagerFeatureModule() = module {
    single { ChannelManagerRepository(get(), get()) }
    single { ChannelManagerService() }
    viewModel { ChannelManagerViewModel(get(), get()) }
    viewModel { AgencyAllotmentViewModel(get()) }
}
